
/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AcceptContractTermsRequest,
  TermsResource,
} from '../models';
import {
    AcceptContractTermsRequestFromJSON,
    AcceptContractTermsRequestToJSON,
    TermsResourceFromJSON,
    TermsResourceToJSON,
} from '../models';

export interface AcceptContractTermsOperationRequest {
    projectId: string;
    acceptContractTermsRequest: AcceptContractTermsRequest;
}

export interface GetTermsRequest {
    projectId: string;
}

/**
 * 
 */
export class ProjectTermsApi extends runtime.BaseAPI {

    /**
     * Accept contract invoicing mode and/or terms
          */
    async acceptContractTermsRaw(requestParameters: AcceptContractTermsOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling acceptContractTerms().'
            );
        }

        if (requestParameters['acceptContractTermsRequest'] == null) {
            throw new runtime.RequiredError(
                'acceptContractTermsRequest',
                'Required parameter "acceptContractTermsRequest" was null or undefined when calling acceptContractTerms().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/terms`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AcceptContractTermsRequestToJSON(requestParameters['acceptContractTermsRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Accept contract invoicing mode and/or terms
          */
    async acceptContractTerms(requestParameters: AcceptContractTermsOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acceptContractTermsRaw(requestParameters, initOverrides);
    }

    /**
     * Fetch the terms
          */
    async getTermsRaw(requestParameters: GetTermsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<TermsResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getTerms().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<TermsResource>({
            path: `/project-client/api/project/{projectId}/terms`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=TermsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch the terms
          */
    async getTerms(requestParameters: GetTermsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<TermsResource> {
        const response = await this.getTermsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
